__turbopack_context__.v({
  "block": "hVra3q_block",
  "bordered": "hVra3q_bordered",
  "btn": "hVra3q_btn",
  "buttonDiv": "hVra3q_buttonDiv",
  "danger": "hVra3q_danger",
  "default": "hVra3q_default",
  "dense": "hVra3q_dense",
  "disabled": "hVra3q_disabled",
  "fab": "hVra3q_fab",
  "facebook": "hVra3q_facebook",
  "facet": "hVra3q_facet",
  "facetChildList": "hVra3q_facetChildList",
  "facetChildListIsChild": "hVra3q_facetChildListIsChild",
  "facetInput": "hVra3q_facetInput",
  "google": "hVra3q_google",
  "grayDark": "hVra3q_grayDark",
  "grayLight": "hVra3q_grayLight",
  "iconWrapper": "hVra3q_iconWrapper",
  "iconed": "hVra3q_iconed",
  "linkBtn": "hVra3q_linkBtn",
  "linkedin": "hVra3q_linkedin",
  "primary": "hVra3q_primary",
  "raised": "hVra3q_raised",
  "rounded": "hVra3q_rounded",
  "secondary": "hVra3q_secondary",
  "success": "hVra3q_success",
  "twitter": "hVra3q_twitter",
  "warning": "hVra3q_warning",
  "wrapper": "hVra3q_wrapper",
  "xing": "hVra3q_xing",
});
